export function getPaginatedItems<T>(
  items: T[],
  page: number,
  pageSize: number,
) {
  const total = items.length
  const totalPages = Math.max(1, Math.ceil(total / pageSize))
  const safePage = Math.min(Math.max(page, 1), totalPages)
  const startIndex = (safePage - 1) * pageSize

  return {
    total,
    totalPages,
    safePage,
    items: items.slice(startIndex, startIndex + pageSize),
    hasNextPage: safePage < totalPages,
    hasPreviousPage: safePage > 1,
  }
}
